import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { DetailClientForm } from "../form/DetailClientForm";
import { ClientDetailResponse } from "../../../core/api/requests/client/detail/types";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    client: ClientDetailResponse;
};

export const DetailClientModal: React.FC<Props> = ({ isOpen, onClose, client }) => {
    return (
        <ModalTemplate
            isOpen={isOpen}
            title="Client Details"
            onClose={onClose}
            maxWidth="800px"
        >
            <DetailClientForm client={client} />
        </ModalTemplate>
    );
}; 